// MUI components
import React, { useState } from "react";
import FaiBadge from "../../../../MuiComponents/FaiBadge";
import {ColumnData} from "../../../../assets/types/ColumnData";
import EditIcon from "../../../../assets/images/icons/edit.svg";
import FaiBox from "../../../../MuiComponents/FaiBox";
import {NavLink} from "react-router-dom";
import {alpha, Button, Chip, CircularProgress, Switch} from "@mui/material";
import {styled} from "@mui/material/styles";
import SwitchBase from "@mui/material/internal/SwitchBase";
import {SwitchProps} from "@mui/material/Switch/Switch";
import FaiTypography from "../../../../MuiComponents/FaiTypography";
import { toast } from "react-toastify";
import { ReturnOrderController } from "../../../../controllers/returnOrderController";

// Per-row Approve / Reject actions for a merchant's return. Shown inline so the
// merchant doesn't have to expand the row. Buttons only appear while the return
// is still REQUESTED; otherwise a status chip is shown.
function ReturnActionsCell({ row }: any) {
    const d = row?.original?.details || {};
    const status: string = d.approvalStatus || "REQUESTED";
    const [busy, setBusy] = useState(false);
    const color = status === "APPROVED" ? "success" : status === "REJECTED" ? "error" : "warning";

    const run = async (fn: () => Promise<any>, ok: string) => {
        setBusy(true);
        try {
            await fn();
            toast.success(ok);
            d.onRefresh && (await d.onRefresh());
        } catch (e: any) {
            toast.error(e?.response?.data?.errors?.[0] || "Action failed");
        } finally {
            setBusy(false);
        }
    };

    if (status !== "REQUESTED") {
        return <Chip label={status} color={color as any} size="small" />;
    }
    return (
        <FaiBox sx={{ display: "flex", gap: "8px" }}>
            <Button
                size="small"
                variant="outlined"
                disabled={busy}
                sx={{
                    color: "#d32f2f",
                    borderColor: "#d32f2f",
                    whiteSpace: "nowrap",
                    "&:hover": { borderColor: "#b71c1c", background: "rgba(211,47,47,0.06)" },
                }}
                onClick={() => {
                    const reason = window.prompt("Reason for rejecting this return (shown to the customer):");
                    if (reason == null) return;
                    if (!reason.trim()) { toast.error("A rejection reason is required"); return; }
                    run(() => ReturnOrderController.rejectReturn(d.id, reason.trim()), "Return rejected");
                }}
            >
                Reject
            </Button>
            <Button
                size="small"
                variant="contained"
                disabled={busy}
                sx={{ background: "#2e7d32", color: "#fff", whiteSpace: "nowrap", "&:hover": { background: "#1b5e20" } }}
                onClick={() => run(() => ReturnOrderController.approveReturn(d.id), "Return approved")}
            >
                {busy ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : "Approve"}
            </Button>
        </FaiBox>
    );
}

const columns: ColumnData[] = [
    {
        Header: "Product name",
        accessor: "productName",
        Cell: ({value, row}) => {
            return (
                <div {...row.getToggleRowExpandedProps()}>
                    <FaiBox>
                        <FaiTypography variant={"caption"}>{row.cells[0].column.Header}</FaiTypography>
                    </FaiBox>
                    <FaiBox>
                        <FaiTypography variant={"h1"} sx={{fontSize:"14px"}} fontWeight={"medium"}>{value}</FaiTypography>
                    </FaiBox>
                </div>
            )
        }
    },
    {
        Header: "Quantity",
        accessor: "qty",
        Cell: ({value, row}) => {
            return (
                <div {...row.getToggleRowExpandedProps()}>
                    <FaiBox>
                        <FaiTypography variant={"caption"}>{row.cells[1].column.Header}</FaiTypography>
                    </FaiBox>
                    <FaiBox>
                        <FaiTypography variant={"h1"} sx={{fontSize:"14px"}} fontWeight={"medium"}>{value}</FaiTypography>
                    </FaiBox>
                </div>
            )
        }
    },
    {
        Header: "Reason of return",
        accessor: "reason",
        Cell: ({value, row}) => {
            return (
                <div {...row.getToggleRowExpandedProps()}>
                    <FaiBox>
                        <FaiTypography variant={"caption"}>{row.cells[2].column.Header}</FaiTypography>
                    </FaiBox>
                    <FaiBox>
                        <FaiTypography variant={"h1"} sx={{fontSize:"14px"}} fontWeight={"medium"}>{value}</FaiTypography>
                    </FaiBox>
                </div>
            )
        }
    },
    {
        Header: "Date",
        accessor: "date",
        Cell: ({value, row}) => {
            return (
                <div {...row.getToggleRowExpandedProps()}>
                    <FaiBox>
                        <FaiTypography variant={"caption"}>{row.cells[3].column.Header}</FaiTypography>
                    </FaiBox>
                    <FaiBox>
                        <FaiTypography variant={"h1"} sx={{fontSize:"14px"}} fontWeight={"medium"}>{value}</FaiTypography>
                    </FaiBox>
                </div>
            )
        }
    },
    {
        Header: "Price",
        accessor: "price",
        Cell: ({value, row}) => {
            return (
                <div {...row.getToggleRowExpandedProps()}>
                    <FaiBox>
                        <FaiTypography variant={"caption"}>{row.cells[4].column.Header}</FaiTypography>
                    </FaiBox>
                    <FaiBox>
                        <FaiTypography variant={"h1"} sx={{fontSize:"14px"}} fontWeight={"medium"}>{value}</FaiTypography>
                    </FaiBox>
                </div>
            )
        }
    },
    {
        Header: "Action",
        accessor: "action",
        Cell: ReturnActionsCell,
    },
];

const rows: any = [
    {
        qty: 1,
        productName: ["BKLGO Full Zip Hoodie"],
        reason: "Clothing",
        price: "$1,321",
        date: "2021-10-10",
        details:{
            address: "1234 Main St",
        }
    },
    {
        qty: 2,
        productName: ["BKLGO Full Zip Hoodie"],
        reason: "Clothing",
        price: "$1,321",
        date: "2021-10-10",
        details:{
            address: "1234 Main St 1",
        }
    }
];

const dataTableData = {
    columns,
    rows,
};

export default dataTableData;

